import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const WarehouseListRBAC = {
  pageID: '483b86d1c8666bf7747792ad481f98ba',
  elementID: {
    BtnAddProductWarehouse: '0d1c00e19a3e3d192952d178883bc781',
    BtnBulkUploadWarehouseProduct: '996cdb62cb5fbccd722c8d93373ed3b7',
    BtnBulkUploadInventoryTransfer: 'c73db5298c359cffbc23d4ba7432ce72',
    BtnUpdateItemPrice: '5240e5a2bb293d4d11cddbc869be69eb',
    BtnUpdateStatusProductWarehouse: '3161111bc3dff9d31742baed7a15f505',
    BtnViewStockProductDetail: '75aa73279b7e43268c6102091e3df005',
    BtnViewStockTrailing: '8055770c11872fa3ae7b273488226081',
  },
} as const

export const useRBACWarehouseListPage = createUseRBAC(WarehouseListRBAC.elementID)
export type UseRBACWarehouseListPageType = ReturnType<typeof useRBACWarehouseListPage>
